import { render, staticRenderFns } from "./addDrawer.vue?vue&type=template&id=263ecdc0&scoped=true"
import script from "./addDrawer.vue?vue&type=script&lang=js"
export * from "./addDrawer.vue?vue&type=script&lang=js"
import style0 from "./addDrawer.vue?vue&type=style&index=0&id=263ecdc0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ecdc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263ecdc0')) {
      api.createRecord('263ecdc0', component.options)
    } else {
      api.reload('263ecdc0', component.options)
    }
    module.hot.accept("./addDrawer.vue?vue&type=template&id=263ecdc0&scoped=true", function () {
      api.rerender('263ecdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/module/components/addDrawer.vue"
export default component.exports